export default __webpack_public_path__ + "static/media/react.73ac128a.png";